import React, { useEffect, useRef } from 'react';
import uPlot from 'uplot';
import 'uplot/dist/uPlot.min.css';

// Small line chart on uPlot. xs are unix seconds; each series is
// { label, color, values } with nulls for gaps. Pass memoised props, since
// the chart is rebuilt whenever they change.
export default function DiaryChart({ title, xs, series, yRange, height = 220 }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || xs.length === 0) return undefined;
    const plot = new uPlot({
      title,
      width: el.clientWidth || 320,
      height,
      scales: { x: { time: true }, y: yRange ? { range: yRange } : {} },
      series: [{}, ...series.map(s => ({ label: s.label, stroke: s.color, width: 2, spanGaps: true, points: { show: true, size: 6 } }))],
    }, [xs, ...series.map(s => s.values)], el);
    const resize = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(() => plot.setSize({ width: el.clientWidth, height }))
      : null;
    resize?.observe(el);
    return () => {
      resize?.disconnect();
      plot.destroy();
    };
  }, [title, xs, series, yRange, height]);

  if (xs.length === 0) return <p className="diary-chart__empty">No data for {title.toLowerCase()} yet.</p>;
  return <div className="diary-chart" ref={ref} role="img" aria-label={title} />;
}
